export default "__VITE_ASSET__D60biP8___"